







import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import cart from '@/store/modules/cart';

let isClerkLoaded = false;

@Component
export default class Clerk extends Vue {
  private mounted() {
    const clerkConfg = store.state.options.clerk;
    if (clerkConfg.cart_enabled && clerkConfg.key && !isClerkLoaded) {
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.innerHTML = `
      (function(w,d){
          var e=d.createElement('script');e.type='text/javascript';e.async=true;
          e.src=(d.location.protocol=='https:'?'https':'http')+'://cdn.clerk.io/clerk.js';
          var s=d.getElementsByTagName('script')[0];s.parentNode.insertBefore(e,s);
          w.__clerk_q=w.__clerk_q||[];w.Clerk=w.Clerk||function(){w.__clerk_q.push(arguments)};
      })(window,document);
      Clerk('config', {
          key: '${clerkConfg.key}',
          collect_email: true
      });`;

      const headEl = document.querySelector('head') as HTMLElement;
      headEl.appendChild(script);
      isClerkLoaded = true;
    }
  }
  
  get productIds() {
    return JSON.stringify(cart.cart.items.map(i => i.extension_attributes.extproduct_id));
  }

  get tpl() {
    return '@' + store.state.options.clerk.cart_content;
  }
}
